module.exports = __webpack_public_path__ + "img/ForwardPoster.84d73cc3.png";